import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    EntityCacheDispatcher,
    EntityCollectionServiceElementsFactory,
    HttpUrlGenerator,
    Logger,
    QueryParams
} from '@ngrx/data';
import { Observable } from 'rxjs/index';
import { map } from 'rxjs/operators';
import { WebsocketBrokerService } from '../../../core/services/websocket-broker.service';
import { WebSocketEntityCollectionServiceBase } from '../../../state/entity/web-socket-entity-collection-service-base';
import { Appointment } from '../../appointments/state/appointment.model';
import { DateAppointmentEntityDataServiceBase } from './date-appointment-entity-data-service.base';
import { dateAppointmentEntityMetadata, DateAppointmentQueryFilter } from './date-appointment.entity';

@Injectable()
export class DateAppointmentService extends WebSocketEntityCollectionServiceBase<Appointment> {

    queryFilter$: Observable<DateAppointmentQueryFilter>;
    refreshing$: Observable<boolean>;

    constructor(private serviceElementsFactory: EntityCollectionServiceElementsFactory) {
        super(dateAppointmentEntityMetadata.entityName, serviceElementsFactory);

        this.queryFilter$ = this.selectors$['queryFilter$'];
        this.refreshing$ = this.selectors$['refreshing$'];
    }
}

/**
 * This is the data service NgRx Data will use to call from effects to make the actual calls to the backend.
 */
@Injectable()
export class DateAppointmentEntityDataService extends DateAppointmentEntityDataServiceBase<Appointment> {
    constructor(http: HttpClient,
                httpUrlGenerator: HttpUrlGenerator,
                logger: Logger,
                public entityCacheDispatcher: EntityCacheDispatcher,
                public websocketBrokerService: WebsocketBrokerService) {
        super(http, httpUrlGenerator, logger, entityCacheDispatcher, websocketBrokerService, 'DateAppointment', 'appointment-list/');
        logger.log('Created custom Date Appointment EntityDataService');
    }

    getAppointments(parameters: any | QueryParams): Observable<Array<Appointment>> {

        return this.http.post('servlets/ngappointments/', {parameters})
            .pipe(
                map((response: any) => {
                    const appointments = response.appointments;
                    appointments.queryFilter = response.queryFilter;

                    return appointments as any;
                })
            );
    }

    subscribeWebSocketJob(parameters: any | QueryParams): void {
        this.subscribeWebSocketJobWithBody({parameters});
    }

    refreshWebSocketJob(parameters: any | QueryParams): void {
        this.refreshWebSocketJobWithBody({parameters});
    }
}
